/// <reference path="../../vendor/angular/angular.js" />
'use strict';

angular.module('navigationControllers', [
    'ngAnimate',
    'ui.bootstrap',
    'mgcrea.ngStrap',
    'angularMoment',
    'services.authenticatedUser']);